/**
 * 订单状态枚举和工具函数
 */

// 订单状态枚举
export const ORDER_STATUS_ENUM = {
  '0': '待支付',
  '1': '支付处理中',
  '2': '支付成功',
  '5': '证件待审核',
  '6': '证件审核通过',
  '8': '待开卡',
  '9': '开卡成功',
  '11': '待发货',
  '12': '已发货',
  '13': '待收货',
  '14': '已收货',
  '15': '待评价',
  '16': '已评价',
  '30': '开卡中',
  '40': '已激活',
  '41': '激活强充',
  '42': '已首充',
  '3': '支付失败',
  '4': '订单取消',
  '7': '证件审核失败',
  '10': '开卡失败',
  '20': '退款',
  '21': '系统审核失败',
  '43': '激活失败',
  '50': '已拒收',
  '60': '推送到系统失败',
};

// 订单状态分类 - 橙色状态 (0,1,2,5,6,8,9)
export const ORDER_STATUS_ORANGE = ['0', '1', '2', '5', '6', '8', '9'];

// 订单状态分类 - 绿色状态 (11,12,13,14,15,16,30,40,41,42)  
export const ORDER_STATUS_GREEN = ['11', '12', '13', '14', '15', '16', '30', '40', '41', '42'];

// 订单状态分类 - 红色状态 (3,4,7,10,20,21,43,50,60)
export const ORDER_STATUS_RED = ['3', '4', '7', '10', '20', '21', '43', '50', '60'];

/**
 * 获取订单状态名称
 * @param {string|number} status - 订单状态码
 * @returns {string} 状态名称
 */
export function getOrderStatusName(status) {
  if (status === null || status === undefined) {
    return '未知状态';
  }
  return ORDER_STATUS_ENUM[String(status)] || '未知状态';
}

/**
 * 获取订单状态颜色分类
 * @param {string|number} status - 订单状态码
 * @returns {string} 颜色分类 ('orange', 'green', 'red', 'unknown')
 */
export function getOrderStatusColor(status) {
  if (status === null || status === undefined) {
    return 'unknown';
  }
  const statusStr = String(status);
  
  if (ORDER_STATUS_ORANGE.includes(statusStr)) {
    return 'orange';
  } else if (ORDER_STATUS_GREEN.includes(statusStr)) {
    return 'green';
  } else if (ORDER_STATUS_RED.includes(statusStr)) {
    return 'red';
  }
  return 'unknown'; // 意外的状态值
}

/**
 * 获取订单状态样式类名
 * @param {string|number} status - 订单状态码
 * @returns {string} 对应的样式类名
 */
export function getOrderStatusClass(status) {
  const color = getOrderStatusColor(status);
  switch (color) {
    case 'orange':
      return 'status-orange';
    case 'green':
      return 'status-success';
    case 'red':
      return 'status-fail';
    default:
      return 'status-unknown';
  }
}

/**
 * 获取订单状态颜色样式
 * @param {string|number} status - 订单状态码
 * @returns {Object} 对应的颜色样式
 */
export function getOrderStatusStyle(status) {
  const color = getOrderStatusColor(status);
  switch (color) {
    case 'orange':
      return { color: '#e6a23c', fontWeight: 600 };
    case 'green':
      return { color: '#67c23a', fontWeight: 600 };
    case 'red':
      return { color: '#f56c6c', fontWeight: 600 };
    default:
      return { color: '#909399', fontWeight: 500 }; // 未知状态使用灰色
  }
}